export enum DownloadFormat {
  XLS = 'XLS',
  CSV = 'CSV',
}

export const LIST_DOWNLOAD_FORMAT = [
  { value: DownloadFormat.XLS, label: 'xls' },
  { value: DownloadFormat.CSV, label: 'csv' },
];
